import { actionTypes } from '../actions/runtime';

export default function runtime(state = {}, action) {
  switch (action.type) {
    case actionTypes.SET_RUNTIME_VARIABLE:
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    default:
      return state;
  }
}
